<div class="shipment-totals-info-container">
  <span class="shipment-totals-info-container__header">{{ "LABELS.TOTALS" | translate }}:</span>
  <div class="shipment-totals-info__item" *ngIf="!!aggregatedStatistics">
    <span class="shipment-totals-info__item-label">{{ "UNITS" | translate }}</span>
    <span class="shipment-totals-info__item-value">{{ aggregatedStatistics.totalPackages }}</span>
  </div>

  <div class="shipment-totals-info__item" *ngIf="!!aggregatedStatistics">
    <span class="shipment-totals-info__item-label">{{ "LABELS.WEIGHT" | translate }}</span>
    <span class="shipment-totals-info__item-value">
      {{ aggregatedStatistics?.realMeasurements?.totalWeight }} {{ "WEIGHT_UNIT.TON" | translate }}
    </span>
  </div>

  <div class="shipment-totals-info__item" *ngIf="!!aggregatedStatistics">
    <span class="shipment-totals-info__item-label">{{ "LABELS.VOLUME" | translate }}</span>
    <span class="shipment-totals-info__item-value">
      {{ aggregatedStatistics?.realMeasurements?.totalVolume }} {{ "LENGTH_UNIT.CBM" | translate }}
    </span>
  </div>
</div>
